import ApiService from '@/core/services/ApiService';
import { Actions, Mutations } from '@/store/enums/StoreEnums';
import { Module, Action, Mutation, VuexModule } from 'vuex-module-decorators';

export interface AuctionsDescriptionsObject {
  id: number;
  titleEn: string;
  titleAr: string;
  isActive: boolean;
}

export interface AuctionsDescriptionsListInfo {
  totalItems: number;
  currentPage: number;
  pageSize: number;
  isNext: boolean;
  previous: number;
  types: Array<AuctionsDescriptionsObject>;
  errors: unknown;
}

@Module
export default class AuctionsDescriptionsModule
  extends VuexModule
  implements AuctionsDescriptionsListInfo
{
  types = [] as Array<AuctionsDescriptionsObject>;
  allTypes = [] as Array<AuctionsDescriptionsObject>;
  totalItems = 0;
  currentPage = 1;
  pageSize = 10;
  previous = 0;
  isNext = true;
  errors = {};

  /**
   * Get types list
   * @returns Array<AuctionsLocationsObject>
   */
  get auctionDescriptionsList(): Array<AuctionsDescriptionsObject> {
    return this.types;
  }

  /**
   * Get all types list
   * @returns Array<PropertyTypeObject>
   */
  get allAuctionsDescriptionsList(): Array<AuctionsDescriptionsObject> {
    return this.allTypes;
  }

  /**
   * Get total items
   * @returns number
   */
  get auctionDescriptionsListCount(): number {
    return this.totalItems;
  }

  @Mutation
  [Mutations.SET_AUCTION_DESCRIPTIONS](data) {
    this.types = data.data;
    this.totalItems = data.totalItems;
    this.currentPage = data.currentPage;
    this.pageSize = data.pageSize;
    this.isNext = data.isNext;
    this.previous = data.previous;
    this.errors = {};
  }

  @Mutation
  [Mutations.SET_ALL_AUCTION_DESCRIPTIONS](data) {
    this.allTypes = data.data;
  }

  @Mutation
  [Mutations.SET_AUCTION_DESCRIPTIONS_CURRENT_PAGE](page) {
    this.currentPage = page;
  }

  @Mutation
  [Mutations.RESET_AUCTION_DESCRIPTIONS_LIST]() {
    this.types = [] as Array<AuctionsDescriptionsObject>;
    this.totalItems = 0;
    this.currentPage = 1;
    this.pageSize = 10;
    this.previous = 0;
    this.isNext = true;
    this.errors = {};
  }

  @Action
  [Actions.CREATE_AUCTION_DESCRIPTION](data) {
    ApiService.setAuthorizationHeader();
    return ApiService.post('/auctions-descriptions', data)
      .then(() => {
        this.context.commit(Mutations.SET_AUCTION_DESCRIPTIONS_CURRENT_PAGE);
      })
      .catch(({ response }) => {
        this.context.commit(Mutations.SET_ERROR, {
          [response.statusText]: [response.data.message],
        });
      });
  }

  @Action
  [Actions.DELETE_AUCTION_DESCRIPTION](id) {
    ApiService.setAuthorizationHeader();
    return ApiService.delete('/auctions-descriptions', id)
      .then(() => {
        this.context.commit(Mutations.SET_AUCTION_DESCRIPTIONS_CURRENT_PAGE);
      })
      .catch(({ response }) => {
        this.context.commit(Mutations.SET_ERROR, {
          [response.statusText]: [response.data.message],
        });
      });
  }

  @Action
  [Actions.UPDATE_AUCTION_DESCRIPTION]({ id, data }) {
    ApiService.setAuthorizationHeader();
    return ApiService.update('/auctions-descriptions', id, data)
      .then(() => {
        this.context.commit(Mutations.RESET_AUCTION_DESCRIPTIONS_LIST);
      })
      .catch(({ response }) => {
        this.context.commit(Mutations.SET_ERROR, {
          [response.statusText]: [response.data.message],
        });
      });
  }

  @Action
  [Actions.UPDATE_AUCTION_DESCRIPTIONS_CURRENT_PAGE](val) {
    this.context.commit(Mutations.SET_AUCTION_DESCRIPTIONS_CURRENT_PAGE, val);
  }

  @Action
  [Actions.GET_AUCTION_DESCRIPTION](id) {
    ApiService.setAuthorizationHeader();
    return ApiService.get('/auctions-descriptions', id);
  }

  @Action
  [Actions.GET_AUCTION_DESCRIPTIONS]() {
    ApiService.setAuthorizationHeader();
    return ApiService.query('/auctions-descriptions', {
      params: { page: this.currentPage },
    })
      .then(({ data }) => {
        this.context.commit(Mutations.SET_AUCTION_DESCRIPTIONS, data);
      })
      .catch(({ response }) => {
        console.error(response);
        // this.context.commit(Mutations.SET_ERROR, {
        //   [response.statusText]: [response.data.message],
        // });
      });
  }

  @Action
  [Actions.GET_ALL_AUCTION_DESCRIPTIONS]() {
    ApiService.setAuthorizationHeader();
    return ApiService.get('/auctions-descriptions/all')
      .then(({ data }) => {
        this.context.commit(Mutations.SET_ALL_AUCTION_DESCRIPTIONS, data);
      })
      .catch(({ response }) => {
        console.error(response);
        // this.context.commit(Mutations.SET_ERROR, {
        //   [response.statusText]: [response.data.message],
        // });
      });
  }
}
